import { Injectable } from '@angular/core';
import { BaseApi } from './_base-api';
import { DataImportCreate, DataImportEntity, ImportDataResponse } from '../models';

@Injectable({
  providedIn: 'root'
})
export class DataImportApiService extends BaseApi<DataImportEntity> {
  constructor() {
    super('');
  }

  getLatestImportDetails() {
    return http$.get<DataImportEntity>(`/DataImport/admin/GetLastDataImport`);
  }

  importData(model: DataImportCreate) {
    return http$.post<ImportDataResponse>(`/DataImport/admin/ImportData`, model);
  }
}
